import React from 'react';
import { useRouteMatch, Link, generatePath, Route, Switch } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import routes from '../routes';
import { Colors } from '../assets/theme/Colors';
import SDChatDesktop from '../pages/Chat/SDChatDesktop/SDChatDesktop';
import EmailsView from './EmailsView';
import SmsView from './SmsView';
import useHasActiveFeatureFlag from '../hooks/useFeatureFlags';
import { FF_CHAT } from '../components/FeatureFlagWrapper';

const linkSx = {
  textDecoration: 'none',
  color: Colors.gray,
  paddingLeft: '10px',
  '&.active': {
    color: 'primary.main',
    position: 'relative',
    '&:before': {
      content: '""',
      position: 'absolute',
      left: -3,
      top: 0,
      height: '100%',
      borderLeft: '4px solid',
      borderColor: 'primary.main',
    },
  },
};

const CommunicationsView = () => {
  const { url } = useRouteMatch();
  const hasActiveChatFF = useHasActiveFeatureFlag(FF_CHAT);

  const communicationsList = [
    ...(hasActiveChatFF
      ? [
          {
            name: 'Chat',
            component: SDChatDesktop,
            path: generatePath(routes.communications, { tab: 'chat' }),
            tab: 'chat',
          },
        ]
      : []),
    {
      name: 'Sent Emails',
      component: EmailsView,
      path: generatePath(routes.communications, { tab: 'emails' }),
      tab: 'emails',
    },
    {
      name: 'Sent SMS',
      component: SmsView,
      path: generatePath(routes.communications, { tab: 'sms' }),
      tab: 'sms',
    },
  ];

  const paths = communicationsList.map((communication) => communication.path);

  const getActiveTab = () => {
    const path = paths.indexOf(url);

    return Math.max(path, 0);
  };

  return (
    <>
      <Typography variant="h5">Communications</Typography>
      <Box mt={5} display="flex" gap="16px">
        <Box minWidth="max-content">
          {communicationsList.map((communication, index) => (
            <Typography variant="subtitle2" key={communication.name} gutterBottom>
              <Box
                component={Link}
                sx={linkSx}
                className={index !== getActiveTab() ? '' : 'active'}
                to={communication.path}
                key={communication.name}
              >
                {communication.name}
              </Box>
            </Typography>
          ))}
        </Box>
        <Box sx={{ width: 'calc(100% - 170px)' }}>
          <Switch>
            {communicationsList.map((communication, index) => (
              <Route
                exact
                path={index === 0 ? [generatePath(routes.communications), communication.path] : communication.path}
                component={communication.component}
                key={communication.name}
              />
            ))}
          </Switch>
        </Box>
      </Box>
    </>
  );
};

export default CommunicationsView;
